module.exports = __webpack_public_path__ + "static/media/greenBack5.a3523822.jpg";